<template>
    <structure>
        <section class="dashboard">
            <section class="title">
                <h1>Olá {{fullname}}</h1>
                <p>Seja muito bem vindo.</p>
            </section>
            <section class="menu">
                <section class="item">
                    <div class="box" @click="goTo('minha-conta')">
                        <h2>Minha Conta</h2>
                        <div class="content">
                            <div class="icon">
                                <i class="fal fa-id-badge"></i>
                            </div>
                            <div class="text">Mantenha seus dados cadastrais e conta de acesso atualizado.</div>
                        </div>
                    </div>
                </section>
                <section class="item" v-if="isPermission('tickets_list')">
                    <div class="box" @click="goTo('ouvidoria')">
                        <h2>Ouvidoria</h2>
                        <div class="content">
                            <div class="icon">
                                <i class="fal fa-user-headset"></i>
                            </div>
                            <div class="text">Registre ou consulte solicitações de atendimento.</div>
                        </div>
                    </div>
                </section>
                <section class="item" v-if="isPermission('edit_my_curriculum')">
                    <div class="box" @click="goTo('meu-curriculo')">
                        <h2>Meu Currículo</h2>
                        <div class="content">
                            <div class="icon">
                                <i class="fal fa-address-card"></i>
                            </div>
                            <div class="text">Mantenha seu currículo atualizado. Complete ou edite seus dados.</div>
                        </div>
                    </div>
                </section>
                <section class="item" v-if="isPermission('jobs_list')">
                    <div class="box" @click="goTo('consultar-vagas')">
                        <h2>Consultar Vagas</h2>
                        <div class="content">
                            <div class="icon">
                                <i class="fal fa-user-graduate"></i>
                            </div>
                            <div class="text">Consulte nosso banco de oportunidades.</div>
                        </div>
                    </div>
                </section>
            </section>
        </section>
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import permissions from '@/mixins/permissions'
    import { storage } from '@/services'
    export default {
        name: 'login',
        components: { structure },
        mixins: [permissions],
        computed:  {
            fullname(){
                return this.user.first_name + ' ' + this.user.last_name
            }
        },
        data(){
            return {
                user: null,
            }
        },
        methods: {
            goTo(page){
                this.$router.push({ path: page })
            },
        },
        created(){
            this.user = storage.getUser()
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
